import { Button, Card, Col, Form } from "react-bootstrap";
import { ButtonRemover, ButtonTrash, JRow, JTable, JTBody, JTHead, MakeMessageError } from "../../../components/Components";
import { formatMoeda, getUuidV4, goToFocus, handleNumberOnly } from "../../../utils/utils";
import { SelectObjectRemoveInterface, VagaoInterface } from "../../../interfaces";
import { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { RootState } from "../../../app/store";
import { useDispatch, useSelector } from "react-redux";
import { changeModalFerroviarioTrem, clearError, removeVagaoTodos } from "../../../features/manifestoSlice";
import { addVagao, removeVagao } from "../../../features/manifestoSlice";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";

const initialFormVagao: VagaoInterface = {
    id: 0,
    nseq: '',
    nvag: '',
    pesobc: 0,
    pesor: 0,
    serie: '',
    tpvag: '',
    tu: 0
}

export default function Trem() {
    const [selecionado, setSelecionado] = useState<number | string>('');
    const dispatch = useDispatch();
    const errors = useSelector((state: RootState) => state.manifesto.listaErrors);
    const form = useSelector((state: RootState) => state.manifesto.manifesto.modal_ferroviario.trem);
    const lista = useSelector((state: RootState) => state.manifesto.manifesto.modal_ferroviario.vag);
    const [formVagao, setFormVagao] = useState<VagaoInterface>(initialFormVagao);
    const pesoBcRef = useRef<HTMLInputElement>(null)
    const pesoRealRef = useRef<HTMLInputElement>(null)
    const serieRef = useRef<HTMLInputElement>(null)
    const nVagaoRef = useRef<HTMLInputElement>(null)
    const tpVagRef = useRef<HTMLInputElement>(null)
    const nSeqRef = useRef<HTMLInputElement>(null)
    const toneladaUtilRef = useRef<HTMLInputElement>(null)
    const { alertModal, ModalMessageEl } = useModalMessage();
    const { confirm, ConfirmModal } = useQuestion();

    const handleChangeTrem = (e: any) => {
        const { name, value } = e.target;
        dispatch(changeModalFerroviarioTrem({ [name]: value }));
        dispatch(clearError('modal_ferroviario_trem_' + name))
    }

    const handleAddVag = () => {
        if (validarPreenchimento()) {
            dispatch(addVagao({
                ...formVagao,
                id: getUuidV4()
            }));
            setFormVagao(initialFormVagao);
        }
    }

    const validarPreenchimento = () => {
        if (formVagao.pesobc === 0 || formVagao.pesobc.toString().trim() === "") {
            goToFocus(pesoBcRef);
            alertModal('Informe Peso Base (Frete) Ton.');
            return false;
        }

        if (formVagao.pesor === 0 || formVagao.pesor.toString().trim() === "") {
            goToFocus(pesoRealRef);
            alertModal('Informe Peso Real Ton.');
            return false;
        }

        if (formVagao.serie.trim() === "") {
            goToFocus(serieRef);
            alertModal("Informe a série.");
            return false;
        } else {
            const regex = /^[A-Za-z0-9]{3}$/;
            if (!regex.test(formVagao.serie.trim())) {
                goToFocus(serieRef);
                alertModal("A série deve ter 3 caracteres.");
                return false;
            }
        }

        if (formVagao.tpvag.trim() !== "") {
            const regex = /^[A-Za-z0-9]{3}$/;

            if (!regex.test(formVagao.tpvag.trim())) {
                alertModal("Tipo vagão deve ter 3 caracteres.");
                goToFocus(tpVagRef);
                return false;
            }
        }

        if (formVagao.nvag.trim() === "") {
            goToFocus(nVagaoRef);
            alertModal("Informe o número do vagão.");
            return false;
        } else {
            const regex = /^[1-9][0-9]{0,7}$/;
            if (!regex.test(formVagao.nvag.trim())) {
                goToFocus(nVagaoRef);
                alertModal("Número do vagão com formato inválido. Digite um numero entre 1 e 99999999");
                return false;
            }
        }

        if (formVagao.nseq.trim() !== "") {
            const regex = /^[1-9]{1}[0-9]{0,2}$/;
            if (!regex.test(formVagao.nseq.trim())) {
                goToFocus(nSeqRef);
                alertModal(
                    "Sequência com formato inválido. Digite número entre 1 e 999 (sem zero a esquerda). Ex: 1, 56, 321."
                );
                return false;
            }
        }

        if (formVagao.tu === 0 || formVagao.tu.toString().trim() === "") {
            goToFocus(toneladaUtilRef);
            alertModal('Informe a Tonelada Útil');
            return false;
        }

        if (lista.find((item: VagaoInterface) => item.nvag.trim() === formVagao.nvag.trim())) {
            goToFocus(nVagaoRef);
            alertModal('Número de vagão já adicionado.');
            return false;
        }

        return true;
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setFormVagao((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id)
        const confirmed = await confirm({
            message: <>Deseja realmente remover Num. Vagão: <strong>{value.title}</strong> ?</>,
            title: "Confirmação"
        });
        if (confirmed) {
            dispatch(removeVagao(value.id))
        }
        setSelecionado('')
    }

    const handleRemoverTodos = async () => {
        if (lista.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todos ?</>,
                title: "Confirmação"
            });
            if (confirmed) {
                dispatch(removeVagaoTodos());
            }
        }
    }

    return (<div className="px-2 g-3">

        <Card className="card-primary card-outline mb-2">
            <Card.Header>
                Informações da composição do trem
            </Card.Header>
            <Card.Body>
                <JRow className="mb-3">
                    <Col md>
                        <Form.Group controlId="ferr-xpref">
                            <Form.Label>* Prefixo do trem</Form.Label>
                            <Form.Control type="text" name="xpref" maxLength={10} value={form.xpref}
                                className={`${errors.modal_ferroviario_trem_xpref?.length > 0 ? "is-invalid" : ""}`}
                                onChange={handleChangeTrem} />
                            <MakeMessageError errors={errors} field="modal_ferroviario_trem_xpref" />
                        </Form.Group>
                    </Col>
                    <Col md={'auto'}>
                        <Form.Group controlId="ferr-dhtrem">
                            <Form.Label>Dt/Hr. Lib.</Form.Label>
                            <Form.Control type="datetime-local" name="dhtrem" maxLength={21} value={form.dhtrem}
                                className={`${errors.modal_ferroviario_trem_dhtrem?.length > 0 ? "is-invalid" : ""}`}
                                onChange={handleChangeTrem} />
                            <MakeMessageError errors={errors} field="modal_ferroviario_trem_dhtrem" />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="ferr-qvag">
                            <Form.Label>* Qtd. Vagões</Form.Label>
                            <Form.Control type="number" name="qvag" maxLength={3}
                                className={`${errors.modal_ferroviario_trem_qvag?.length > 0 ? "is-invalid" : ""}`}
                                value={form.qvag}
                                onChange={handleChangeTrem} />
                            <MakeMessageError errors={errors} field="modal_ferroviario_trem_qvag" />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="ferr-xori">
                            <Form.Label>* Origem do Trem</Form.Label>
                            <Form.Control type="text" name="xori" maxLength={3} value={form.xori}
                                className={`${errors.modal_ferroviario_trem_xori?.length > 0 ? "is-invalid" : ""}`}
                                onChange={handleChangeTrem} />
                            <MakeMessageError errors={errors} field="modal_ferroviario_trem_xori" />
                        </Form.Group>
                    </Col>
                    <Col md>
                        <Form.Group controlId="ferr-xdest">
                            <Form.Label>* Destino do trem</Form.Label>
                            <Form.Control type="text" name="xdest" maxLength={3} value={form.xdest}
                                className={`${errors.modal_ferroviario_trem_xdest?.length > 0 ? "is-invalid" : ""}`}
                                onChange={handleChangeTrem} />
                            <MakeMessageError errors={errors} field="modal_ferroviario_trem_xdest" />
                        </Form.Group>
                    </Col>
                </JRow>

            </Card.Body>
        </Card>

        <Card className="card-primary card-outline">
            <Card.Header>
                Informações dos Vagões <span className="text-danger">(Obs: Adicionar pelo menos um vagão)</span>
            </Card.Header>
            <Card.Body>
                <JRow className="mb-3">
                    <Col md>
                        <Form.Group controlId="ferr-pesobc">
                            <Form.Label className="">* Peso Base (Frete) Ton.</Form.Label>
                            <Form.Control type="number" name="pesobc" value={formVagao.pesobc} ref={pesoBcRef}
                                onChange={(e) => {
                                    const { name, value } = e.target;
                                    setFormVagao({
                                        ...formVagao,
                                        [name]: value.replace(/[^0-9.]/g, "")
                                            .replace(/^(\d{0,3})\d*/, "$1")
                                            .replace(/(\.\d{3})\d+/, "$1")
                                    })
                                }}
                            />
                        </Form.Group>
                    </Col>
                    <Col md>
                        <Form.Group controlId="ferr-pesor">
                            <Form.Label>* Peso Real Ton.</Form.Label>
                            <Form.Control type="number" name="pesor" value={formVagao.pesor} ref={pesoRealRef}
                                onChange={(e) => {
                                    const { name, value } = e.target;
                                    setFormVagao({
                                        ...formVagao,
                                        [name]:
                                            value.replace(/[^0-9.]/g, "")
                                                .replace(/^(\d{0,3})\d*/, "$1")
                                                .replace(/(\.\d{3})\d+/, "$1")
                                    })
                                }}
                            />
                        </Form.Group>
                    </Col>
                    <Col md>
                        <Form.Group controlId="ferr-tpvag">
                            <Form.Label>Tipo de Vagão</Form.Label>
                            <Form.Control type="text" name="tpvag" maxLength={3} value={formVagao.tpvag}
                                ref={tpVagRef}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>

                </JRow>

                <JRow className="mb-3">
                    <Col md>
                        <Form.Group controlId="ferr-serie">
                            <Form.Label>* Série</Form.Label>
                            <Form.Control type="text" name="serie" maxLength={3} value={formVagao.serie}
                                ref={serieRef}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col md>
                        <Form.Group controlId="ferr-nvag">
                            <Form.Label>* Núm. Vagão</Form.Label>
                            <Form.Control type="text" name="nvag" maxLength={8} value={formVagao.nvag}
                                ref={nVagaoRef}
                                onChange={handleChange} onKeyUp={handleNumberOnly}
                            />
                        </Form.Group>
                    </Col>
                    <Col md>
                        <Form.Group controlId="ferr-nseq">
                            <Form.Label>Sequência</Form.Label>
                            <Form.Control type="text" name="nseq" maxLength={3} value={formVagao.nseq}
                                ref={nSeqRef}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="ferr-tu">
                            <Form.Label>* Tonelada Ùtil</Form.Label>
                            <Form.Control type="number" name="tu" value={formVagao.tu} ref={toneladaUtilRef}
                                onChange={(e) => {
                                    const { name, value } = e.target;
                                    setFormVagao({
                                        ...formVagao,
                                        [name]:
                                            value.replace(/[^0-9.]/g, "")
                                                .replace(/^(\d{0,3})\d*/, "$1")
                                                .replace(/(\.\d{3})\d+/, "$1")
                                    })
                                }}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={'auto'} className="d-flex  align-items-end">

                        <Form.Group className="">

                            <Button variant="primary" onClick={handleAddVag}>
                                <FontAwesomeIcon icon={faPlus} />  Adicionar
                            </Button>
                        </Form.Group>
                    </Col>

                </JRow>

                <JTable>
                    <JTHead >
                        <tr>
                            <th className="text-center" style={{ width: '4rem' }}>
                                <ButtonTrash onClick={() => handleRemoverTodos()} />
                            </th>
                            <th className="text-center">Série</th>
                            <th className="text-center" style={{ width: '7rem' }}>Num. Vagão</th>
                            <th className="text-center" >Peso Base Frete T.</th>
                            <th className="text-center">Peso Real T.</th>
                            <th className="text-center">Tonelada útil</th>
                        </tr>
                    </JTHead>

                    <JTBody>
                        {lista?.map((item: VagaoInterface) => (
                            <tr key={item.id} className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                                <td className="text-center">
                                    <ButtonRemover onClick={() => handleRemover({ id: item.id, title: item.nvag })} />
                                </td>
                                <td className="text-center">{item.serie}</td>
                                <td className="text-center">{item.nvag}</td>
                                <td className="text-center">{formatMoeda(item.pesobc, 3, 'decimal')}</td>
                                <td className="text-center">{formatMoeda(item.pesor, 3, 'decimal')}</td>
                                <td className="text-center">{formatMoeda(item.tu, 3, 'decimal')}</td>
                            </tr>
                        ))}
                    </JTBody>
                </JTable>
            </Card.Body>
        </Card>
        {ModalMessageEl}
        {ConfirmModal}
    </div>)
}